import { IGenerateTagsModel } from 'components/Pages/Admin/AttendanceList/types';
import { IAttendaceList, IAttendanceMultiple, IEditPresence } from 'interfaces/attendanceList';
import { IEvent, IEventList } from 'interfaces/event';
import { ITags } from 'interfaces/tags';
import { User } from 'services/user/types';
import { create } from 'zustand';

interface Pagination {
  page: number;
  totalPages: number;
  size: number;
  totalRows: number;
}

interface IState {
  isOpenModalSendEmailToParticipants: boolean;
  emailToParticipantesInviteKeysSelected: string[];
  isOpenResendTicket: boolean;
  isOpenLabelManager: boolean;
  isOpenEdit: boolean;
  isOpenEditMultiple: boolean;
  isOpenMarkerMultiple: boolean;
  isOpenAttendanceDetail: boolean;
  isOpenAttendanceList: boolean;
  model: IEditPresence;
  inviteMultipleData: IAttendanceMultiple;
  events: Array<IEventList>;
  loading: boolean;
  tags: ITags[];
  client: IAttendaceList;
  participantsToPrint: IAttendaceList[];
  isOpenModalLink: boolean;
  data: IAttendaceList[];
  eventDetail: Partial<IEvent>;
  userEmail: string;
  pagination: Pagination;
  hasAppliedAdvancedFilter: boolean;
  filter: any;
  eventFilterSelected: any;
  eventIdSelected: string;
  hasAttendanceChanges: boolean;
  user: User;
  noTickets: boolean;
  selectedParticipants: IAttendaceList[];
  allPagesParticipantsAreSelected: boolean;
  isMultipleAction: boolean;
  isEventLiveOnline: boolean;
  generateTagsModel: IGenerateTagsModel | null;
  isLoadingGenerateTagsModel: boolean;
  cliCodSelected: number | null;
}

interface EventStore extends IState {
  setState: (partial: Partial<IState>) => void;
}

const initialState: IState = {
  isOpenResendTicket: false,
  isOpenModalSendEmailToParticipants: false,
  emailToParticipantesInviteKeysSelected: [],
  isOpenAttendanceDetail: false,
  isOpenAttendanceList: true,
  tags: [],
  isOpenEdit: false,
  isOpenEditMultiple: false,
  isOpenMarkerMultiple: false,
  isOpenModalLink: false,
  isOpenLabelManager: false,
  model: null,
  inviteMultipleData: null,
  userEmail: null,
  client: null,
  participantsToPrint: [],
  loading: false,
  events: [],
  pagination: {
    page: 1,
    totalPages: 1,
    size: 0,
    totalRows: 0
  },
  filter: {},
  hasAppliedAdvancedFilter: false,
  eventDetail: {},
  data: [],
  eventFilterSelected: {},
  eventIdSelected: null,
  hasAttendanceChanges: false,
  user: null,
  noTickets: false,
  selectedParticipants: [],
  allPagesParticipantsAreSelected: false,
  isMultipleAction: false,
  isEventLiveOnline: null,
  generateTagsModel: null,
  isLoadingGenerateTagsModel: true,
  cliCodSelected: null
};

export const useAttendanceListStore = create<EventStore>(set => ({
  ...initialState,
  setState: partial => set(state => ({ ...state, ...partial }))
}));
